import { render, staticRenderFns } from "./AjoutDossier.vue?vue&type=template&id=09adcac8&scoped=true"
import script from "./AjoutDossier.vue?vue&type=script&lang=js"
export * from "./AjoutDossier.vue?vue&type=script&lang=js"
import style0 from "./AjoutDossier.vue?vue&type=style&index=0&id=09adcac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09adcac8",
  null
  
)

export default component.exports